<p-toast></p-toast>

<div class="page">
  <div class="header-action">
    <button class="btn-primary" (click)="openCreateModal()">
      + Créer un bon cadeau
    </button>
  </div>

  <!-- Modale création/édition -->
  <div class="modal" [class.show]="showModal">
    <div class="modal-content compact-create-modal">
      <span class="close-x" (click)="closeModal()">&times;</span>
      <h2 class="compact-modal-title">{{ editingGroup ? 'Modifier le bon' : 'Créer un bon cadeau' }}</h2>

      <form (ngSubmit)="save()" #bonForm="ngForm">
        <div class="compact-help">
          L'acheteur choisit librement son montant sur la marketplace — vous ne définissez que vos
          seuils de réduction.
        </div>

        <div class="form-group">
          <label>Description (optionnel)</label>
          <input type="text" [(ngModel)]="newGroup.description" name="description" />
        </div>

        <div class="form-group">
          <label>Réduction générale (%)</label>
          <input
            type="number"
            [(ngModel)]="newGroup.generalDiscount"
            name="generalDiscount"
            min="0"
            max="99"
            placeholder="Ex. 10"
          />
          <small style="color:#718096;font-size:12px;">
            S'applique dès le premier franc. Si l'acheteur atteint un seuil plus avantageux
            ci-dessous, c'est le seuil qui s'applique (pas de cumul).
          </small>
        </div>

        <!-- Seuils de réduction "à partir de X" — le seul réglage de prix du
             bon : l'acheteur choisit librement son montant, la réduction
             appliquée est celle du seuil le plus haut qu'il atteint. -->
        <div class="form-group">
          <label>Réductions par seuil (optionnel)</label>

          <div class="tier-add-row">
            <input
              type="number"
              [(ngModel)]="tierMinInput"
              name="tierMinInput"
              min="1"
              placeholder="À partir de (ex. 10000)"
            />
            <input
              type="number"
              [(ngModel)]="tierPercentInput"
              name="tierPercentInput"
              min="1"
              max="99"
              placeholder="% réduction"
            />
            <button type="button" class="btn-secondary" (click)="addDiscountTier()">Ajouter</button>
          </div>
          <div class="tier-chips" *ngIf="newGroup.discountTiers.length">
            <span class="tier-chip" *ngFor="let t of newGroup.discountTiers; let i = index">
              {{ t.percent }}% à partir de {{ t.minAmount | number:'1.0-0' }} XOF
              <button type="button" (click)="removeDiscountTier(i)">&times;</button>
            </span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Durée de validité (mois)</label>
            <input
              type="number"
              [(ngModel)]="newGroup.validityMonths"
              name="validityMonths"
              min="1"
              readonly
              tabindex="-1"
              class="read-only-field"
            />
          </div>
          <div class="form-group">
            <label>Max par commande (optionnel)</label>
            <input type="number" [(ngModel)]="newGroup.maxPerOrder" name="maxPerOrder" min="1" />
          </div>
        </div>

        <div class="form-group">
          <label>Stock total (optionnel — laisser vide pour illimité)</label>
          <input type="number" [(ngModel)]="newGroup.stockTotal" name="stockTotal" min="1" />
        </div>

        <div class="error-text" *ngIf="errorMessage" style="color: #e74c3c; font-size: 12px; margin-top: 4px;">
          {{ errorMessage }}
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary" [disabled]="loading">
            {{ loading ? 'Enregistrement...' : 'Enregistrer' }}
          </button>
          <button type="button" class="btn-secondary" (click)="closeModal()">Annuler</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Modale statistiques -->
  <div class="modal" [class.show]="showStatsModal" *ngIf="selectedGroup">
    <div class="modal-content details-modal">
      <span class="close-x" (click)="closeStatsModal()">&times;</span>
      <div class="modal-header-custom">
        <h2>{{ selectedGroup.label }}</h2>
        <p class="subtitle">Statistiques et encours à reverser</p>
      </div>

      <div *ngIf="loadingStats" style="text-align: center; padding: 20px;">Chargement...</div>

      <div *ngIf="!loadingStats && stats" class="history-card">
        <h3>Bons</h3>
        <div class="stats-row">
          <div class="stat-box purple">
            <i class="bi bi-send-check"></i>
            <div><span>Émis</span><strong>{{ stats.emis }}</strong></div>
          </div>
          <div class="stat-box gray">
            <i class="bi bi-check2-circle"></i>
            <div><span>Consommés</span><strong>{{ stats.consommes }}</strong></div>
          </div>
          <div class="stat-box purple">
            <i class="bi bi-arrow-repeat"></i>
            <div><span>En circulation</span><strong>{{ stats.enCirculation }}</strong></div>
          </div>
        </div>

        <h3 style="margin-top: 16px;">Encours à reverser (bons en circulation)</h3>
        <div class="stats-row">
          <div class="stat-box gray">
            <i class="bi bi-cash-stack"></i>
            <div><span>À la faciale</span><strong>{{ stats.encoursFaceValue | number:'1.0-0' }} XOF</strong></div>
          </div>
          <div class="stat-box gray">
            <i class="bi bi-wallet2"></i>
            <div><span>Au prix de vente encaissé</span><strong>{{ stats.encoursSalePrice | number:'1.0-0' }} XOF</strong></div>
          </div>
        </div>
        <p class="activity-line">
          <i class="bi bi-info-circle"></i>
          TiPay détient le prix de vente encaissé, pas la faciale — la différence reste votre remise consentie.
        </p>
        <h3 style="margin-top: 16px;" *ngIf="(stats.byDenomination?.length || 0) > 1">Détail par montant</h3>
        <table class="kids-table" *ngIf="(stats.byDenomination?.length || 0) > 1">
          <thead>
          <tr>
            <th>Montant</th>
            <th>Émis</th>
            <th>Consommés</th>
            <th>En circulation</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let d of stats.byDenomination">
            <td>{{ d.faceValue | number:'1.0-0' }} XOF</td>
            <td>{{ d.emis }}</td>
            <td>{{ d.consommes }}</td>
            <td>{{ d.enCirculation }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Popup de confirmation générique (publier / dépublier / supprimer) -->
  <div class="modal" [class.show]="confirmDialog.visible" *ngIf="confirmDialog.visible">
    <div class="modal-content confirm-modal" style="max-width: 380px;">
      <span class="close-x" (click)="closeConfirm()">&times;</span>
      <h2 class="compact-modal-title">{{ confirmDialog.title }}</h2>
      <p style="margin: 12px 0 20px; color: #4a5568; font-size: 14px;">{{ confirmDialog.message }}</p>
      <div class="form-actions">
        <button
          type="button"
          [class.btn-danger]="confirmDialog.danger"
          [class.btn-primary]="!confirmDialog.danger"
          (click)="confirmAction()"
        >
          {{ confirmDialog.confirmLabel }}
        </button>
        <button type="button" class="btn-secondary" (click)="closeConfirm()">Annuler</button>
      </div>
    </div>
  </div>

  <div class="filters">
    <input type="text" placeholder="Recherche" [(ngModel)]="search" />
    <select [(ngModel)]="statusFilter">
      <option value="ALL">Tous les statuts</option>
      <option value="DRAFT">Brouillon</option>
      <option value="PENDING_APPROVAL">En attente d'approbation</option>
      <option value="ACTIVE">Actif</option>
      <option value="SUSPENDED">Suspendu</option>
      <option value="ARCHIVED">Archivé</option>
    </select>
  </div>

  <div class="table-container">
    <table class="kids-table">
      <thead>
      <tr>
        <th>Montants</th>
        <th>Réduction</th>
        <th>Statut</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let group of filteredGroups()" class="row-clickable">
        <td (click)="openStats(group)">{{ denominationsSummary(group) }}</td>
        <td (click)="openStats(group)">
          <span class="badge" *ngIf="group.generalDiscount || group.discountTiers?.length">{{ discountSummary(group) }}</span>
          <span *ngIf="!group.generalDiscount && !group.discountTiers?.length">—</span>
        </td>
        <td (click)="openStats(group)">
          <span class="status {{ group.status === 'ACTIVE' ? 'active' : (group.status === 'SUSPENDED' || group.status === 'ARCHIVED') ? 'inactive' : '' }}">
            {{ statusLabel(group.status) }}
          </span>
        </td>
        <td class="actions">
          <button
            *ngIf="canEdit(group)"
            class="btn-secondary"
            style="padding: 6px 14px; font-size: 12px;"
            (click)="$event.stopPropagation(); openEditModal(group)"
          >
            Modifier
          </button>
          <button
            *ngIf="canPublish(group)"
            class="btn-primary"
            style="padding: 6px 14px; font-size: 12px; float: none;"
            (click)="$event.stopPropagation(); publish(group)"
          >
            Publier
          </button>
          <button
            *ngIf="canUnpublish(group)"
            class="btn-secondary"
            style="padding: 6px 14px; font-size: 12px;"
            (click)="$event.stopPropagation(); unpublish(group)"
          >
            Dépublier
          </button>
          <button
            *ngIf="canDelete(group)"
            class="btn-danger"
            style="padding: 6px 14px; font-size: 12px;"
            (click)="$event.stopPropagation(); deleteGroup(group)"
          >
            Supprimer
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <p *ngIf="filteredGroups().length === 0" style="text-align: center; padding: 24px; color: #718096;">
      Aucun bon cadeau pour ces critères.
    </p>
  </div>
</div>